export const slotBarSymbolNames = {
  icon1: 'icon1',
  icon2: 'icon2',
  icon3: 'icon3',
  icon4: 'icon4',
  icon5: 'icon5',
  icon6: 'icon6',
  icon7: 'icon7',
  icon8: 'icon8',
  icon9: 'icon9',
};

// RU: символа джекпота (400) и ключей джекпот-сцены нет: джекпот — слой платформы, сервер символ
//     больше не присылает (решение владельца, CORE-CONTRACT §9).
export const slotSpineKey = {
  1: slotBarSymbolNames.icon1,
  2: slotBarSymbolNames.icon2,
  3: slotBarSymbolNames.icon3,
  4: slotBarSymbolNames.icon4,
  5: slotBarSymbolNames.icon5,
  6: slotBarSymbolNames.icon6,
  7: slotBarSymbolNames.icon7,
  8: slotBarSymbolNames.icon8,
  9: slotBarSymbolNames.icon9,
  winLine: 'winLine',
  winPopup: 'winPopup',
  gameLogo: 'gameLogo',
  reSpinText: 'reSpinText',
  gambleCard: 'gambleCard',
  gambleSymbol: 'gambleSymbol',
  gambleAmountFrame: 'gambleAmountFrame',
  // RU: огненная сцена телефона (components/wildFireScene) — спайн mainBg из frame-пака ядра.
  mainBg: 'mainBg',
};

// RU: лента иконок-наполнителей барабана (helpers/spinIconNumberProvider). Wild в ней нет.
export const randomGeneratedIcons = [
  '4',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '4',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
];

export const iconStates = {
  win: 'win',
  idle: 'idle',
  blur: 'blur',
  noWin: 'noWin',
  winExpand: 'winExpand',
};

// RU: scatter у игры нет — только wild (раскрывающаяся звезда).
export const specialIconKeys = {
  wild: 9,
};
